export default "__VITE_ASSET__QGk$yAJM__"